import React from "react";
import PropTypes from "prop-types";

const Male = ({
  height,
  width,
  strokeFill,
  fill,
  containerFill,
  containerStrokeFill,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 45 45" fill={containerFill}>
      <circle
        cx={22.7091}
        cy={21.8746}
        r={21.1246}
        stroke={containerStrokeFill}
        strokeWidth={1.5}
      />
      <path
        d="M26.239 33.287H20.49l-5.004-10.986s7.377-2.65 16 0L26.24 33.287z"
        stroke={strokeFill}
        fill={fill}
      />
      <circle
        cx={23.1846}
        cy={13.7906}
        r={3.77981}
        stroke={strokeFill}
        fill={fill}
      />
    </svg>
  );
};

Male.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
  strokeFill: PropTypes.string,
  containerFill: PropTypes.string,
  containerStrokeFill: PropTypes.string,
};

Male.defaultProps = {
  height: 44,
  width: 45,
  fill: "#ffffff",
  strokeFill: "#000000",
  containerFill: "none",
  containerStrokeFill: "#E31C79",
};

export default Male;
